
import React, { PureComponent } from 'react';
import "./Forms.css";
// add .error to component for error state.

class Input extends PureComponent {
  static defaultProps = {
    isInvalid: '',
    Type: 'text',
    Pattern: "",
    Selected: "",
    isDisabled: "",
    alert: '',
    ariaLabel: '',
    autoComplete: 'off'
  };
  constructor(props) {
    super(props);
  }

  render() {
    const isInvalid = (this.props.isInvalid.length ? this.props.isInvalid : '');
    return (
      <div className="form-wrapper">
        <input
          type={this.props.Type}
          name={this.props.name}
          placeholder={this.props.placeholder}
          autoComplete={this.props.autoComplete}
          onChange={this.props.onChange}
          value={this.props.Value}
          className={(isInvalid.length < 1 && this.props.alert.length < 1 ? "" : "error")}
          defaultValue={this.props.Selected || this.props.defaultValue}
          disabled={this.props.isDisabled.length ? true : false}
          aria-label={this.props.ariaLabel}
        />


        {this.props.children && <span tabIndex="0" className="Input-label">{this.props.children}</span>}
        {(isInvalid.length < 1 ? "" : <span tabIndex="0" className="input-errorLabel"> {isInvalid}</span>)}
        {(this.props.alert.length < 1 ? "" : <span tabIndex="0" className="input-errorLabel"> {this.props.alert}</span>)}
      </div>
    );
  }
}
export default Input;
